import { toBig } from "@tradingApp/components/Trading/helpers/big";

export const TRADING_MAX_DECIMALS = 6;

export const TRADING_MAX_SIGNIFICANT_DIGITS = 5;

export function tradingPriceRound(
  price: number | string,
  szDecimals = 0,
  currency?: "USD",
  padWithZero = true,
): string {
  const currencyPrefix = currency === "USD" ? "$" : "";
  const priceBig = toBig(price);
  const decimals = TRADING_MAX_DECIMALS - szDecimals;
  const [intPart, decPart = ""] = price.toString().split(".");
  const isPriceBelowOne = priceBig.lt(1);

  if (!isPriceBelowOne && intPart.length >= TRADING_MAX_SIGNIFICANT_DIGITS) {
    return intPart;
  }

  const signifacantDigits = priceBig
    .round(decimals, 0)
    .toString()
    .replace(/\./, "")
    .replace(/^0+/, "");

  const signifacantDigitsCount = signifacantDigits.length;

  const maxSignificantDigitsSliceEnd = !isPriceBelowOne
    ? TRADING_MAX_SIGNIFICANT_DIGITS - intPart.length
    : TRADING_MAX_SIGNIFICANT_DIGITS;

  let fractionalSliced = padWithZero ? decPart.padEnd(decimals, "0") : decPart;

  if (isPriceBelowOne) {
    const decimalsRest =
      signifacantDigitsCount > TRADING_MAX_SIGNIFICANT_DIGITS
        ? TRADING_MAX_SIGNIFICANT_DIGITS
        : decimals;

    fractionalSliced = fractionalSliced.slice(0, decimalsRest);
  } else {
    fractionalSliced = fractionalSliced.slice(0, maxSignificantDigitsSliceEnd);
  }

  return fractionalSliced
    ? `${currencyPrefix}${intPart}.${fractionalSliced}`
    : `${currencyPrefix}${intPart}`;
}
